<div class="dialog-content-container p-4">
    <div class="flex flex-column gap-4">
        <!-- Validation Errors -->
        @if (hasValidationErrors()) {
        <div class="border-round p-3 bg-red-50 border-1 border-red-300">
            <div class="flex align-items-center gap-2 mb-2">
                <i class="pi pi-exclamation-triangle text-red-500"></i>
                <span class="font-semibold text-red-700">
                    {{ 'SEND_ORDER_TO_REVIEW.VALIDATION_HEADER' | translate }}
                </span>
            </div>
            <ul class="m-0 pl-4">
                @for (error of salesSupportErrors(); track error.key) {
                <li class="text-red-700">{{ error.key | translate }}</li>
                }
            </ul>
        </div>
        }

        @if (showCreditCheck() && !embedded()) {
        <div class="flex align-items-center gap-3">
            <p-toggleswitch [ngModel]="creditCheckOK()" (ngModelChange)="creditCheckOK.set($event)"
                inputId="creditCheck" />
            <label for="creditCheck">
                {{ 'REVIEW_OR_CREATE_ORDER.CREDIT_CHECK_CERTIFY' | translate }}
            </label>
        </div>
        }

        <!-- Picks WHICH queue reviews the quote, not whether it goes to review — that is the
             button's job. The flag drives QuoteRepository.GetAllGlobal, which is how the central
             cross-company team finds its work; off, it stays with the quote's own company. -->
        <div class="flex align-items-center gap-3">
            <p-toggleswitch [ngModel]="toCentralSalesSupport()" (ngModelChange)="toCentralSalesSupport.set($event)"
                inputId="toCentralSalesSupport" />
            <label for="toCentralSalesSupport">
                {{ 'REVIEW_OR_CREATE_ORDER.TO_CENTRAL_SALES_SUPPORT' | translate }}
            </label>
        </div>
    </div>

    <!-- Actions. Suppressed when embedded: the stepper footer drives the flow instead. -->
    @if (!embedded()) {
    <div class="flex justify-content-end gap-2 mt-5">
        <p-button [label]="'ABORT' | translate" [text]="true" (onClick)="onCancel()" />
        <p-button [label]="'SEND_ORDER_TO_REVIEW.CONFIRM_BTN' | translate" [disabled]="!canConfirm()"
            (onClick)="onConfirm()" />
    </div>
    }
</div>